import EventSessionFormPageActionTypes from './event-session-form-page-action-types';
import ValidationError from '../../../utils/validation-error';

export const loadSessionFormPage = ({ eventId, sessionId }) => async(dispatch, getState, { api }) => {
  dispatch({ type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_START });
  try {
    const event = await api.get(`api/general_competency_events/${eventId}`);
    const eventStartDate = event.startDate ? new Date(event.startDate) : null;
    const eventEndDate = event.endDate ? new Date(event.endDate) : null;

    if (sessionId > 0) {
      const session = await api.get(`api/general_competency_events/${eventId}/sessions/${sessionId}`);
      const startAtDate = session.startAt ? new Date(session.startAt) : null;
      const startAtTime = session.startAt ? new Date(session.startAt) : null;
      dispatch({
        type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END,
        payload: {
          session: {
            ...session,
            startAtDate,
            startAtTime
          },
          eventName: event.name,
          eventStartDate,
          eventEndDate
        }
      });
    } else {
      dispatch({
        type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END,
        payload: {
          session: {
            startAtDate: eventStartDate
          },
          eventName: event.name,
          eventStartDate,
          eventEndDate
        }
      });
    }
  } catch (error) {
    dispatch({ type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END });
    throw error;
  }
};

export const saveSession = (payload) => async(dispatch, getState, { api, history }) => {
  dispatch({ type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_START });
  const state = getState().generalCompetencyEventSessionFormPage;
  const { eventId, ...apiModel } = payload;
  let id = payload?.id;
  try {
    if (id > 0) {
      await api.put(`api/general_competency_events/${eventId}/sessions/${id}`, apiModel);
    } else {
      id = await api.post(`api/general_competency_events/${eventId}/sessions`, apiModel);
    }
    dispatch({
      type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END,
      payload: {
        session: {
          ...state.session,
          id: id
        }
      }
    });
    history.back();
  } catch (error) {
    let validationResult = null;
    if (error instanceof ValidationError) {
      validationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({
      type: EventSessionFormPageActionTypes.LOAD_EVENT_SESSION_FORM_PAGE_END,
      payload: {
        validationResult,
        session: state.session
      }
    });
  }
};

export const cancelSessionFormPage = () => async(dispatch, getState) => {
  const state = getState().generalCompetencyEventSessionFormPage;
  state.cancellationTokenSources?.forEach(token => {
    token?.cancel();
  });
};
